import { useTranslation } from "react-i18next";
import { cn } from "../../../utils/cn";
import './card.css';

type size = 'sm' | 'md' | 'lg';
type CardProps = {
    title?: string;
    children: React.ReactNode;
    className?: string;
    size?: size;
    titleKey?: string;
};

export const Card = ({
    title, titleKey, children, className = '', size = 'lg',
}: CardProps) => {
    const {t} = useTranslation();
    return (
        <section className={cn('custom__card', `custom__card__${size}`, className)}>
            <div className="custom__card__header">
                {title && <div className="custom__card__title">{titleKey ? t(`other:cardTitles.${titleKey}`) : title}</div>}
            </div>
            <div className="custom__card__content">{children}</div>
        </section>
    )
}